import React, { useMemo } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { getFlightDealDuration } from 'lib/flights/flightUtils'

import InlineGroup from 'components/Common/InlineGroup'
import LineInfoCircleIcon from 'components/Luxkit/Icons/line/LineInfoCircleIcon'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Spacing from 'components/Common/Spacing'

const Root = styled(InlineGroup)`
  border-radius: ${props => props.theme.borderRadius.M};
  padding: ${rem(12)} ${rem(16)};
  background-color: ${({ theme }) => theme.palette.neutral.seven};
`

const Block = styled(Spacing)`
  flex-direction: column;
`

const DatesLabel = styled(BodyText)`
  white-space: pre-wrap;
`

interface Props {
  flightDeal: App.FlightDeal;
}

function FlightDealDuration({ flightDeal }: Props) {
  const { travelPeriods: offerDuration } = flightDeal
  const offerDurationLabel = useMemo(() => getFlightDealDuration(offerDuration), [offerDuration])

  return (
    <Root vertical="center">
      <LineInfoCircleIcon size="S" />
      <Block ml={12}>
        <BodyText variant="medium" weight="bold">
          Save when you fly between:
        </BodyText>
        <DatesLabel variant="medium">
          {offerDurationLabel}
        </DatesLabel>
      </Block>
    </Root>
  )
}

export default FlightDealDuration
